import NDFL3YearLogic2020 from './NDFL3YearLogic2020';
import { CONST_RESIDENT } from '../../constants/CODE_RESIDENT';

export default class NDFL3YearLogic2021 extends NDFL3YearLogic2020 {
  name() {
    return '2021';
  }

  showTaxRate() {
    return false;
  }

  useCountryIstAndZachForIncomesOutsideRF() {
    return true;
  }

  showSumOfSimplifiedTaxDeduction() {
    return true;
  }

  showTaxRateOnlyForOtherIncomes() {
    return true;
  }

  showOnlyCadastralNumberOptionInAddPropertyObjectForm() {
    return true;
  }

  isShowSumOfCorporateIncomeTax() {
    return true;
  }

  showSumOfFixedAdvancePaymentsForIncome() {
    return true;
  }

  showIISData() {
    return true;
  }

  showTaxAmountCalculatedWithDividends() {
    return false;
  }

  showIsHighClassSpecialistField() {
    return true;
  }

  showSumOfMaterialBenefitToRefundField() {
    return true;
  }

  isNewIncomeTypesFilter() {
    return true;
  }

  showNewNdfl3Preview() {
    return true;
  }

  // Применить новую логику формирования доходов
  getTaxRateOptions(isResident = true) {
    // Статус налогоплательщика (1 - резидент РФ, 2 - не резидент РФ)
    if (isResident === CONST_RESIDENT) {
      return [
        { label: '13', value: 13 },
        { label: '15', value: 15 },
        { label: '35', value: 35 },
        { label: '9', value: 9 },
      ];
    }
    return [
      { label: '30', value: 30 },
      { label: '15', value: 15 },
      { label: '13', value: 13 },
    ];
  }

  showSpecialFieldsForDividendsIncome() {
    return false;
  }

  isIncomeSumForYear() {
    return false;
  }

  showLocationInfoIf(objectTypeViewValue) {
    // из за изменения списка вид номера объекта
    return objectTypeViewValue === '2';
  }

  showNumberObject() {
    return false;
  }
}
